import { i18n } from '@/plugins/i18n'
import store from '@/store'
import descriptionColumn from './descriptionColumn'
import { requestType, requestTypeStr } from '@/constants/DedicatedRequestType';
import { requestStatus, requestStatusStr, requestVariant } from '@/constants/DedicatedRequestStatus';

const descriptionTemplate = (row, index, datatable) => {
    let template = new descriptionColumn({
        props: {
            row,
            index,
            datatable,
            store,
        },
        i18n,
    });

    template.row = row;
    template.index = index;
    template.datatable = datatable;
    template.store = store;

    return template.$mount().$el;
}

export default [
    {
        field: 'id',
        title: '#',
        sortable: false,
        width: 40,
        textAlign: 'center',
    },
    {
        field: 'shop_name',
        title: i18n.t('label.gateway'),
        sortable: false,
        textAlign: 'center',
        template: (row) => {
            return '<a target="_blank" href="/dedicated/update/' + row.shop_id + '">' + row.shop_name + '</a>';
        },
    },
    {
        field: 'type',
        title: i18n.t('label.request_type'),
        sortable: false,
        textAlign: 'center',
        template: (row) => {
            return `<span>${requestTypeStr.get(row.type)}</span>`;
        },
    },
    {
        field: 'status',
        title: i18n.t('label.status'),
        sortable: false,
        textAlign: 'center',
        template: (row) => {
            return `<span class="badge badge-${requestVariant(row.status)}">${requestStatusStr.get(row.status)}</span>`;
        },
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'description',
        title: i18n.t('label.description'),
        sortable: false,
        textAlign: 'center',
        template: (row, index, datatable) => {
            if (row.status == requestStatus.CREATED) {
                if (row.type == requestType.UPDATE_RELATED_MERCHANT_LIST) {
                    return descriptionTemplate(row, index, datatable);
                }
            }

            return `<span>${row.description}</span>`;
        },
    },
]